import React, { useEffect, useState } from 'react';
import { store } from '../../../app/store';
import { postAPI } from '../../../app/api';
import { ToastContainer, toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { hasPermission, isAdmin } from '../../../store/hooks/Permission';
import FormSubmissionHandler from '../../../UIComponents/FormSubmissionHandler';
import SelectBoxHandler from '../../../UIComponents/SelectBoxHandler';
import NormalTextareaHandler from '../../../UIComponents/NormalTextareaHandler';
import InputHandler from '../../../UIComponents/InputHandler';
import InputGroupHandler from '../../../UIComponents/InputGroupHandler';
import Loader from '../../../UIComponents/Loader';
import { useParams } from 'react-router-dom';

export default function Form({ Page = "", is_edit = 0, edit_id = 0 }) {
    const { exam_id } = useParams();
    const [IsBTNClicked, setIsBTNClicked] = useState(false);
    const store_data = JSON.parse(store());
    const [canCreate, setCanCreate] = useState(false);
    const [canEdit, setCanEdit] = useState(false);
    const [ExamData, setExamData] = useState([]);
    const [FormData, setFormData] = useState({ exam_id: exam_id });
    const [Editing, setEditing] = useState(is_edit);
    const [Error, setError] = useState([]);
    const [Loading, setLoading] = useState(true);

    useEffect(() => {
        const checkPermissions = async () => {
            if (isAdmin()) {
                setCanCreate(true);
                setCanEdit(true);
            } else {
                const createAllowed = await hasPermission("REWARDS", "RewardSetup", "CREATE");
                const editAllowed = await hasPermission("REWARDS", "RewardSetup", "EDIT");
                setCanCreate(createAllowed);
                setCanEdit(editAllowed);
            }
        };
        checkPermissions();

        setLoading(false);
    }, [is_edit, edit_id]);

    const validate = () => {
        let errors = [];
        if (!FormData.total_prize || isNaN(FormData.total_prize) || FormData.total_prize < 1) errors.push('Total Prizes must be a positive number.');
        if (FormData.total_prize) {
            for (let i = 1; i <= FormData.total_prize; i++) {
                const val = FormData[`rank_wise_prize[${i}]`];
                if (!val || val?.length <= 0) errors.push(`Reward Amount for Rank ${i} must not be a blank value.`);
            }
        }
        setError(errors);
        return errors.length === 0;
    };

    const handleSubmit = async () => {
        setIsBTNClicked(true);
        if (IsBTNClicked) return;
        
        if (!isAdmin() && ((is_edit && !canEdit) || (!is_edit && !canCreate))) {
            toast.error('You do not have permission to perform this action.');
            setIsBTNClicked(false);
            return;
        }
        
        if (!validate()) {
            toast.error('Please fix validation errors.');
            return;
        }
        setIsBTNClicked(true);
        const payload = { org_id: store_data?.org_id, user: store_data, ...FormData };
        const response = await postAPI(is_edit ? "/reward-setup/update" : "/reward-setup/create", {...payload, user: store_data});
        if (response?.status) {
            setIsBTNClicked(false);
            toast.success('Reward setup saved successfully.');
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        } else {
            setIsBTNClicked(false);
            toast.error('Sorry ! Invalid Request. We cannot proceed with this request for now.');
        }
    }
    return (
        <>
            {Loading ? <Loader /> :
                store_data?.role === 'EMPLOYEE' && !hasPermission ? (
                    <div className="alert alert-danger">You do not have permission to access this form.</div>
                ) : (
                    <FormSubmissionHandler handleSubmit={handleSubmit} editing={is_edit} error={Error} BTNLabel="Save" IsBTNClicked={IsBTNClicked}>
                        <div className="col-12 col-md-6">
                            <InputHandler
                                form_data={FormData}
                                setFormData={setFormData}
                                Name="total_prize"
                                Type="number"
                                Label="Total Prizes"
                            />
                        </div>
                        {FormData?.total_prize ? (
                            Array.from({ length: FormData.total_prize }).map((_, index) => (
                                <div className="col-12 col-md-6" key={index}>
                                    <InputHandler
                                        form_data={FormData}
                                        setFormData={setFormData}
                                        Name={`rank_wise_prize[${index + 1}]`}
                                        Type="text"
                                        Label={`Reward for Rank ${index + 1}`}
                                    />
                                </div>
                            ))
                        ) : null}
                        {Error.length > 0 && (
                            <div className="alert alert-danger">
                                <ul>{Error.map((e, i) => <li key={i}>{e}</li>)}</ul>
                            </div>
                        )}
                    </FormSubmissionHandler>
                )
            }
            <ToastContainer position="bottom-right" autoClose={5000} hideProgressBar={true} closeOnClick={true} pauseOnHover={false} draggable={false} progress="1" theme="dark" transition={Slide} />
        </>
    )
}
